import {ReactSVG} from "react-svg";

const Logo = (props) => (
    <ReactSVG src="../assets/images/logo.svg" />
  // <img
  //   alt="Logo"
  //   src="../assets/images/logo.svg"
  //   {...props}
  // />
);

export default Logo;
